export default "__VITE_ASSET__C80GW40e__"